export default __webpack_public_path__ + "assets/images/26638ae838f43a59f90715ca2d6118bd.jpg";